import React from 'react'
import { Link } from 'react-router-dom'
import './Healthcontainer.css'
const Healthcontaner = () => {
    return (
        <>
            <section id='healthcontainer'>
                <div className='d-flex justify-content-center'>
                    <div className='f'>
                        <h1>Ensure your employee gets</h1>
                        <h1>the best</h1>
                        <div className='mt-29'>
                            <h6>Our customers have got better business ROIs with high eNPS,</h6>
                            <h6> better CSAT, lower attrition & higher sales performance.</h6>
                        </div>

                    </div>

                </div>





                <section id='last' className='mt-3'>
                    {/* css in cradholder.css */}
                    <div className="container">
                        <div className="last-grid-container">
                            <div class="last-item1">
                                <div className='poi'>
                                    <h1>
                                        Free Video consultation</h1>

                                </div>

                                <div className="lorem-mt">
                                    <div className='text-box'>

                                    </div>
                                    <h6 class="card-subtitle text1 text-muted">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt laborum, impedit provident repellat adipisci sint maxime recusandae, quod quis expedita aliquam soluta ipsa saepe repudiandae eaque tenetur consequatur omnis voluptatibus!
                                    </h6>
                                </div>
                                <div className="k-wrap">
                                    <div className=' hi'>
                                        <h3>6.7M</h3>
                                        <p>Nulla facilisis.</p>
                                    </div>
                                    <div className=' '>
                                        <h3>56.2K</h3>
                                        <p>Nulla facilisis.</p>
                                    </div>
                                </div>
                                <Link class="hover text-decoration-none text-violet learn">Learn More<i class="p-2 fa-solid fa-circle-arrow-right"></i> </Link>


                            </div>
                            <div class="last-item2">
                                <div className="img-box">
                                    <img class=' last-img' src="./images/healthinsurance/1.svg" alt="" />
                                </div>

                            </div>
                            <div class="last-item3">
                                <div className='img-box'>
                                    <img className='' src="./images/healthinsurance/2.svg" alt="" />
                                </div>

                            </div>
                            <div class="last-item4">


                                <div className='mt-45'>
                                    <h1>Customized Corporate health
                                        insurence</h1>
                                </div>


                                <div className="lorem-mt">
                                    <h6 class="card-subtitle text1 text-muted">
                                        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deleniti incidunt tenetur ab molestias ea reiciendis nam dolores amet magni qui quis doloribus aspernatur, distinctio, temporibus id quasi, aperiam possimus pariatur.

                                    </h6>
                                </div>
                                <div className="k-wrap">
                                    <div className=' hi'>
                                        <h3>6.7M</h3>
                                        <p>Nulla facilisis.</p>
                                    </div>
                                    <div className=' '>
                                        <h3>56.2K</h3>
                                        <p>Nulla facilisis.</p>
                                    </div>
                                </div>
                                <Link class="hover text-decoration-none text-violet learn">Learn More<i class="p-2 fa-solid fa-circle-arrow-right"></i> </Link>


                            </div>
                            <div class="last-item1">

                                <div className='poi'>
                                    <h1>
                                        30% Discount on wellnes </h1>
                                    <h1>packeges</h1>

                                </div>

                                <div className="lorem-mt">
                                    <h6 class="card-subtitle text1 text-muted">
                                        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Atque repudiandae suscipit reiciendis. Illo ipsa distinctio, doloribus rerum odit nam molestiae laboriosam perferendis quam qui nemo similique! Necessitatibus sequi hic doloribus?
                                    </h6>
                                </div>
                                <div className="k-wrap">
                                    <div className=' hi'>
                                        <h3>6.7M</h3>
                                        <p>Nulla facilisis.</p>
                                    </div>
                                    <div className=' '>
                                        <h3>56.2K</h3>
                                        <p>Nulla facilisis.</p>
                                    </div>
                                </div>
                                <div>
                                    <Link class="hover text-decoration-none text-violet learn">Learn More<i class="p-2 fa-solid fa-circle-arrow-right"></i> </Link>

                                </div>
                            </div>
                            <div class="last-item2">
                                <div className="img-box">
                                    <img className='last-img ' src="./images/healthinsurance/3.svg" alt="" />
                                </div>

                            </div>
                            <div class="last-item3">
                                <div className='img-box'>
                                    <img className='' src="./images/healthinsurance/5.svg" alt="" />
                                </div>

                            </div>
                            <div class="last-item4">

                                <div className="mt-75">
                                    <h1>Group  life insurence
                                    </h1>
                                </div>


                                <div className="lorem-mt">
                                    <h6 class="card-subtitle text1 text-muted">
                                        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Atque repudiandae suscipit reiciendis. Illo ipsa distinctio, doloribus rerum odit nam molestiae laboriosam perferendis quam qui nemo similique! Necessitatibus sequi hic doloribus?
                                    </h6>
                                </div>
                                <div className="k-wrap">
                                    <div className=' hi'>
                                        <h3>6.7M</h3>
                                        <p>Nulla facilisis.</p>
                                    </div>
                                    <div className=' '>
                                        <h3>56.2K</h3>
                                        <p>Nulla facilisis.</p>
                                    </div>
                                </div>
                                <div>
                                    <Link class="hover text-decoration-none text-violet learn">Learn More<i class="p-2 fa-solid fa-circle-arrow-right"></i> </Link>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>


            <div className='suno-na mt-172' style={{ position: "relative" }}>
             
 
                <div className='text-above text-center'>
                     <h2>Partnering with the best</h2>
                </div>
               
                <div className="health-suno-na-wrap" style={{ background: "rgba(253, 150, 68, 0.18)" }}>
               
                    <div className='left-box'>
                        <div>
                            <h1>Give them Choice to choose</h1>
                            <h1>best</h1>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry
                                . Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer
                                took a galley of type and scrambled it to make a type specimen book.
                            </p>
                        </div>
                    </div>
                    <div className=' big-box shadow hover-shadow'>

                        <div className="text-center">
                            <h1>Gift Vouchers</h1>
                        </div>
                        <div className="white-box shadow">




                            <div>
                                <div className="health-white-grid-container">


                                    <div>
                                        <img className='img-fluid' src="./images/healthinsurance/bajaj1.svg" alt="" />
                                        <img className='img-fluid' src="./images/healthinsurance/bajaj2.svg" alt="" />
                                    </div>
                                    <div>
                                       
                                    </div>
                                   
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}

export default Healthcontaner